import { writable, get } from 'svelte/store';
import type { Book } from '@legere/storage-manager';
import { getBookStorage } from '../lib/storage';

export const books = writable<Book[]>([]);
export const selectedBook = writable<Book | null>(null);

/**
 * Book Store API
 */
export const bookStore = {
  get books() {
    return get(books);
  },

  /**
   * Import EPUB file (placeholder - will trigger BookUpload logic)
   */
  async importEpub(_file: File): Promise<void> {
    // This will be handled by BookUpload component
    throw new Error('Please use BookUpload component for file import');
  },

  /**
   * Import markdown bundle (placeholder - will trigger BookUpload logic)
   */
  async importBundle(_file: File): Promise<void> {
    // This will be handled by BookUpload component
    throw new Error('Please use BookUpload component for file import');
  },

  /**
   * Update book metadata (including tags)
   */
  async updateBook(bookId: string, updates: Partial<Book>): Promise<void> {
    const storage = getBookStorage();
    const book = await storage.getBook(bookId);

    if (!book) {
      throw new Error(`Book not found: ${bookId}`);
    }

    const updatedBook = { ...book, ...updates };
    await storage.updateBook(bookId, updatedBook);

    const updatedBooks = await storage.getAllBooks();
    books.set(updatedBooks);
  },

  /**
   * Load all books from storage
   */
  async loadBooks(): Promise<void> {
    const storage = getBookStorage();
    const loadedBooks = await storage.getAllBooks();
    books.set(loadedBooks);
  },
};
